import {
  FormControl,
  FormControlLabel,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';


export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));

export const InlineFormControl = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: theme.spacing(4),
  '.MuiFormLabel-root.MuiInputLabel-root': {
    marginBottom: 0,
  },
}));

export const RadioLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: '0px',
  marginRight: theme.spacing(1),
  '& .MuiTypography-root': {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const EndpointRow = styled(TableRow)(() => ({
  verticalAlign: 'top',
}));

export const EndpointItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));

export const LatencyContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'disabled',
})(({ theme, disabled }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  ...(disabled && {
    color: theme.palette.text.disabled,
  }),
}));

export const EmptyStateImage = styled('img')(({ theme }) => ({
  margin: `${theme.spacing(20)} auto`,
  height: '180px',
  opacity: '50%',
  display: 'block',
}));
